<template>
    <div v-if="html" v-html="html" class="markdown-html"></div>
</template>

<script>
import Showdown from "showdown"

export default {
    name: "MarkdownDisplay",
    props: {
        markdown: {
            type: String,
            required: false,
            default: "",
        },
    },
    computed: {
        html() {
            if (!this.markdown) {
                return null
            }
            const converter = new Showdown.Converter()
            // Convert the markdown to html.
            return converter.makeHtml(this.markdown)
        },
    },
}
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.markdown-html {
    p {
        margin-bottom: $spacer * 0.5;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-size: 1rem;
    }
}
</style>